import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-fill text-background-50 text-lg"></i>
            </div>
            <span className="text-xl font-bold text-foreground-950 whitespace-nowrap">嫩草视频</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/reboju"
              className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索影视剧..."
                className="pl-9 pr-4 py-2 text-sm bg-background-100 border border-background-200 rounded-full w-48 focus:w-64 transition-all focus:outline-none focus:border-primary-300 text-foreground-800 placeholder-foreground-400"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-100"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-foreground-800 text-xl`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden border-t border-background-200 py-3 pb-4">
            <div className="flex flex-col gap-1">
              <Link
                to="/"
                className={`px-4 py-3 text-sm rounded-lg transition-colors ${
                  location.pathname === '/' ? 'text-primary-500 bg-primary-50 font-medium' : 'text-foreground-700'
                }`}
              >
                首页
              </Link>
              <Link
                to="/category/reboju"
                className={`px-4 py-3 text-sm rounded-lg transition-colors ${
                  location.pathname.startsWith('/category') ? 'text-primary-500 bg-primary-50 font-medium' : 'text-foreground-700'
                }`}
              >
                分类浏览
              </Link>
              <Link
                to="/about"
                className={`px-4 py-3 text-sm rounded-lg transition-colors ${
                  location.pathname === '/about' ? 'text-primary-500 bg-primary-50 font-medium' : 'text-foreground-700'
                }`}
              >
                关于我们
              </Link>
            </div>
            <div className="relative mt-3 px-4">
              <input
                type="text"
                placeholder="搜索影视剧..."
                className="w-full pl-9 pr-4 py-2.5 text-sm bg-background-100 border border-background-200 rounded-full focus:outline-none focus:border-primary-300 text-foreground-800 placeholder-foreground-400"
              />
              <i className="ri-search-line absolute left-7 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}